/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { IExpandedSlot, IPopupActions } from '../types';
import { Typography } from '../../../atoms';
import { ETypography, ETypographyColor, IColors, Icons } from '../../../types';
import { BnIcon } from '../../../components/icons_v2';
import { Button } from '../../../components/Button';
import { SizeEnum } from '../../../lib/constants';
import { IMainBodyLabels, mainBodyLineCss } from './MainBody';

interface IViewFormsActionProps {
	expandedSlot: IExpandedSlot;
	colors: IColors;
	labels: IMainBodyLabels;
	actions?: IPopupActions;
}

export const ViewFormsAction = ({ expandedSlot, colors, labels, actions }: IViewFormsActionProps) => {

	if (!expandedSlot?.hasApplications || !actions?.viewForms?.allow) {
		return null;
	}

	return (
		<div css={mainBodyLineCss(colors)} data-testid="view-applications">
			<BnIcon icon={Icons.reports} />
			<Button theme="basicLine" sizer={SizeEnum.EXTRA_SMALL} onClick={actions.viewForms?.handle}>
				<Typography color={ETypographyColor.secondary} type={ETypography.overlineLink}>
					{labels.viewForms}
				</Typography>
			</Button>
		</div>
	);
};
